export const initBluecore = () => {
  /* eslint-disable */
  var triggermail=triggermail||[];triggermail.load=function(a){
    var b=document.createElement("script");b.type="text/javascript";
    b.async=!0;b.src="https://api.bluecore.com/triggermail.js/"+a+".js";
    a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(b,a)};
  triggermail.load("the_outset");window.triggermail=triggermail;
  /* eslint-enable */
}
